import { formatDateBySegmentNoYear, formatDateYear } from "../";

type BenchmarkClimateRow = {
  ts: string;
  consumptionV: number;
  conversionRate: number;
  co2: number;
};

type BenchmarkClimateYearData = {
  data: BenchmarkClimateRow[];
  total?: {
    consumptionV?: number;
    co2?: number;
  };
};

export const toBenchmarkDataClimate = (
  shortSegment: string,
  data: BenchmarkClimateYearData[],
  gettext: (key: string) => string,
  addTotal = false,
) => {
  let returnData: Array<Record<string, string | number>> = [];
  let totals: Record<string, number> = {};
  let totalRow: Record<string, string | number> | null = null;

  data.forEach((yearData) => {
    let ts = yearData?.data[0]?.ts;

    if (ts) {
      const year = formatDateYear(ts);

      if (addTotal) {
        if (!totalRow) {
          totalRow = {
            id: "Total",
            label: "Sum/Average",
            ts: gettext("Sum"),
          };
        }
        totalRow[`consumptionV_${year}`] = yearData?.total?.consumptionV || 0;
        totalRow[`conversionRate_${year}`] = "";
        totalRow[`co2_${year}`] = yearData?.total?.co2 || 0;
      }

      yearData.data.forEach((row) => {
        const date = formatDateBySegmentNoYear(row.ts, shortSegment);
        // const year = formatDateYear(row.ts);

        // console.log(date, row.ts);

        // Find if there's already an entry for this date
        let existingEntry = returnData.find((entry) => entry.ts === date);

        if (existingEntry) {
          // If entry exists, add the year data to it
          existingEntry[`consumptionV_${year}`] = row.consumptionV;
          existingEntry[`conversionRate_${year}`] = row.conversionRate;
          existingEntry[`co2_${year}`] = row.co2;
        } else {
          // If entry does not exist, create a new one
          let rowData: Record<string, string | number> = {
            id: date,
            label: date,
            ts: date,
          };
          rowData[`consumptionV_${year}`] = row.consumptionV;
          rowData[`conversionRate_${year}`] = row.conversionRate;
          rowData[`co2_${year}`] = row.co2;
          returnData.push(rowData);
        }

        // Add to totals
        if (!totals[`consumptionV_${year}`]) {
          totals[`consumptionV_${year}`] = 0;
        }
        totals[`consumptionV_${year}`] += row.consumptionV;

        if (!totals[`conversionRate_${year}`]) {
          totals[`conversionRate_${year}`] = 0;
        }
        totals[`conversionRate_${year}`] += row.conversionRate;

        if (!totals[`co2_${year}`]) {
          totals[`co2_${year}`] = 0;
        }
        totals[`co2_${year}`] += row.co2;

        if (!totals["rows"]) {
          totals["rows"] = 0;
        }
        totals["rows"]++;
      });

      // console.log(year, yearData.total);
      // console.log(yearData.total);
    }
  });

  // Create the "Total" row
  // if (addTotal) {
  //   let totalRow = {
  //     id: "Sum",
  //     label: "Sum/Average",
  //     ts: gettext("Sum/Average"),
  //   };
  //
  //   for (const year in totals) {
  //     if (year.startsWith("conversionRate")) {
  //       totalRow[year] = totals[year] / totals["rows"];
  //     } else {
  //       totalRow[year] = totals[year];
  //     }
  //   }
  if (addTotal && totalRow) {
    returnData.push(totalRow);
  }

  return returnData;
};
